module.exports = __webpack_public_path__ + "static/media/Ready.1a09ff4d.svg";